import { toast } from "react-toastify";
import {
  addActiveRequests,
  removeActiveRequests,
  updateLoading,
  updateLoadingMsg,
} from "../../Redux/Reducers/uiSlice";
import { buildCloseStrategyWebSocketPayload } from "./positionsUtils";

const finishCloseStrategyRequest = (dispatch) => {
  dispatch(removeActiveRequests("close_strategy"));
  dispatch(updateLoading(false));
  dispatch(updateLoadingMsg(""));
};



export function handleCloseStrategyWebSocketMessage(data, dispatch, setPreview) {
  const status = data?.status;
  const payload = data?.data;

  if (status === "error") {
    toast.error(
      typeof payload?.message === "string" && payload.message
        ? payload.message
        : "Failed to close positions."
    );
    setPreview(null);
    finishCloseStrategyRequest(dispatch);
    return;
  }

  if (status === "success" && payload?.mode === "preview") {
    setPreview({
      fundId: payload.fundId,
      strategyId: payload.strategyId,
      summary: payload.summary || {},
      orders: Array.isArray(payload.orders) ? payload.orders : [],
    });
    finishCloseStrategyRequest(dispatch);
    return;
  }

  if (status === "success" && payload?.mode === "submitted") {
    const defaultMsg =
      payload?.mode === "submitted"
        ? "Positions are closed successfully."
        : "Close strategy completed.";
    toast.success(
      typeof payload?.message === "string" && payload.message
        ? payload.message
        : defaultMsg
    );
    setPreview(null);
    finishCloseStrategyRequest(dispatch);
  }
}


export function submitCloseStrategyPreview({ send, dispatch, preview, setPreview }) {
  if (!preview?.fundId || !preview?.strategyId) return;

  dispatch(updateLoading(true));
  dispatch(updateLoadingMsg("Submitting close strategy…"));
  dispatch(addActiveRequests("close_strategy"));
  send(
    JSON.stringify(
      buildCloseStrategyWebSocketPayload(preview.fundId, preview.strategyId, true)
    )
  );
  setPreview(null);
}
